<template>
    <div class="row">
        <div class="col-lg-10 mx-auto">
            <!-- {{ sixMonthListArr }} -->
            <!-- Plan Tab Content -->
            <div class="tab-content">
                <!-- {{ agentSession }} -->
                <!-- Monthly Tab -->
                <div class="tab-pane fade active show" id="monthly">
                    <div class="row mb-30 equal-height-cards">
                        <div class="col-md-1">
                        </div>
                        <div class="col-md-5" v-if="aiDetail.id == 0">
                            <div class="card pricing-box">
                                <div class="card-body d-flex flex-column">
                                    <div class="mb-4">
                                        <h3>Gratis</h3>
                                        <span class="display-4">Rp 0</span>
                                    </div>
                                    <ul>
                                        <li><i class="fa fa-check"></i> Aktif di Semua Nomor WA</li>
                                        <li><i class="fa fa-check"></i> Limited Tokens</li>
                                        <li><i class="fa fa-check"></i> Welcome Chat</li>
                                        <li><i class="fa fa-check"></i> Work Chat</li>
                                        <li><i class="fa fa-check"></i> Away Chat</li>
                                        <li><i class="fa fa-check"></i> Masa Aktif 1 Bulan</li>
                                        <li><span class="text text-danger">
                                                <router-link :to="'/subscriptions'"><i class="fa fa-info"></i> Wajib
                                                    punya No WA Waajo Berbayar</router-link></span></li>
                                    </ul>
                                    <a href="javascript:void(0)" @click.prevent="registerTrial"
                                        class="btn btn-lg btn-outline-secondary mt-auto" :disabled="isLoading">Coba
                                        Sekarang</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2" v-else>
                        </div>
                        <div class="col-md-5">
                            <template v-if="sixMonthListArr.length">
                                <div v-for="(row, ind) in sixMonthListArr" :key="ind" class="card pricing-box">
                                    <div class="card-body d-flex flex-column">
                                        <div class="mb-4">
                                            <h3>Addon - Token AI</h3>
                                            <span class="text text-danger" v-if="row.price_gross != row.price_nett">
                                                <i>
                                                    <strike>Rp {{ formatPriceRupiah(row.price_gross) }}</strike>
                                                </i>
                                            </span>
                                            <br />
                                            <span class="display-4">Rp {{ formatPriceRupiah(row.price_nett) }}</span>
                                            <span>/ tanpa batas</span>
                                        </div>
                                        <div v-html="row.description"></div>
                                        <a href="javascript:void(0)" @click.prevent="updateShoppingCart(row.id)"
                                            class="btn btn-lg btn-primary mt-auto" :disabled="isDisabled == 1">Topup</a>
                                    </div>
                                </div>
                            </template>

                            <!-- <div class="card pricing-box">
                                <div class="card-body d-flex flex-column">
                                    <div class="mb-4">
                                        <h3>Addon</h3>
                                        <span class="display-4">Rp 69.900</span>
                                        <br /><span>/tanpa batas</span>
                                    </div>
                                    <ul>
                                        <li><i class="fa fa-check"></i> Semua di Free Trial</li>
                                        <li><i class="fa fa-check"></i> 10M Tokens</li>
                                        <li><i class="fa fa-check"></i> Tanpa Masa Aktif</li>
                                        <li><i class="fa fa-check"></i> Broadcast <i class="text text-info">(soon)</i>
                                        </li>
                                        <li><i class="fa fa-check"></i> Birthday <i class="text text-info">(soon)</i>
                                        </li>
                                        <li><i class="fa fa-check"></i> Chat Room <i class="text text-info">(soon)</i>
                                        </li>

                                    </ul>
                                    <a :href="link_topup" target="_blank"
                                        class="btn btn-lg btn-outline-secondary mt-auto">Topup</a>
                                </div>
                            </div> -->
                        </div>

                    </div>
                </div>
            </div>
            <!-- /Plan Tab Content -->

        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";
import {
    getMemberSession,
} from "@/utils/auth";
import { nFormatter, formatFromUnixToDate, formatPriceRupiah, labelPackageProduct } from "@/utils/helper";
export default {
    data() {
        return {
            isDisabled: 0,
            recaptchaInstance: '',
            token: '',
            isLoading: false,
            link_topup: process.env.VUE_APP_LINK_TOPUP_TOKEN_AI,
            formMonthly: {
                name: "",
                category_id: "tokenai",
                page: 0,
                perPage: 20
            }
        };
    },
    computed: {
        sixMonthListArr() {
            return this.$store.state.product.sixMonthListArr;
        },
        ...mapGetters(["agentSession", "rolesMember"]),
        memberSessionArr() {
            return JSON.parse(this.getMemberSession());
        },
    },
    mounted() {
        if ($('.floating').length > 0) {
            $('.floating').on('focus blur', function (e) {
                $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
            }).trigger('blur');
        }
    },
    props: {
        aiDetail: {
            type: Array
        },
        getAIKey: {
            type: Function
        },
        getBalance: {
            type: Function
        },
        getAIDetail: {
            type: Function
        },
    },
    created() {
        this.recaptcha();
        this.getPublicList();
    },
    methods: {
        async updateShoppingCart(id) {
            this.isDisabled = await 1;

            let productArr = await this.$store.getters.getProductSixMonthListArrById(
                id
            );
            if (typeof productArr.id == undefined || productArr.id == "") {
                this.isDisabled = 0;

                this.$fire({
                    title: "Error",
                    text: "The selected product is not available",
                    type: "error",
                    timer: 3000
                });
            } else {
                await this.$store.dispatch("order/updateShoppingCart", productArr);
                await this.$fire({
                    title: "Success",
                    text: "Your order has been added",
                    type: "success",
                    timer: 3000
                }).then(r => {
                    this.isDisabled = 0;

                    let license_id = this.$route.query.license_id;
                    if (typeof license_id != "undefined" && license_id != "") {
                        this.$router.push("/order?license_id=" + license_id);
                    } else {
                        this.recaptchaInstance.hideBadge()

                        this.$router.push("/order");
                    }
                });
            }
        },
        async getPublicList() {
            this.loading = await true;
            await this.$store.dispatch(
                "product/sixMonthListPublic",
                this.formMonthly
            );
            this.loading = await false;
        },
        async recaptcha() {
            // (optional) Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded()
            // Execute reCAPTCHA with action "login".
            this.token = await this.$recaptcha('registration')
            // console.log("token", this.token)
            this.recaptchaInstance = await this.$recaptchaInstance

            // Hide reCAPTCHA badge:
            // await   recaptcha.hideBadge()

            // Show reCAPTCHA badge:
            await this.recaptchaInstance.showBadge()

            // Do stuff with the received token.
        },
        formatPriceRupiah(value) {
            return formatPriceRupiah(value);
        },
        registerTrial() {
            this.isLoading = true;

            // this.licenseArrLoading = true;
            this.$store
                .dispatch("aiKey/registerTrial") // sesuai kan dengan method di API
                .then(response => {
                    this.isLoading = false
                    // console.log("registerTrial:", response)
                    // let { data } = response;
                    // this.aiDetail = data
                    // console.log("ai detail", data)
                    this.getAIKey();
                    this.getBalance();
                    this.getAIDetail();
                }).catch(() => {
                    this.isLoading = false
                });
        },
        getMemberSession() {
            return getMemberSession();
        },
        async doCreateTransaction(pid) {
            if (this.memberSessionArr != null) {
                this.createTransactionWithLogin(pid);
            } else {
                this.createTransactionNonLogin(pid);
            }
        },
        async createTransactionWithLogin(pid) {
            this.isDisabled = await 1;

            let memberId = await parseInt(this.memberSessionArr.id);

            let paramOrder = {
                header: {
                    network_id: memberId,
                    license_id: this.agentSession.license_id,
                    token: this.token,
                },
                detail: [
                    {
                        product_id: pid
                    }
                ]
            };

            //create order
            await this.$store.dispatch("order/createOrder", paramOrder).catch(e => {
                this.isDisabled = 0;
            }); // sesuai kan dengan method di API
            console.log("this.invoiceArr", this.invoiceArr);
            let paramPayment = await {
                order_id: this.invoiceArr.id,
                member_id: memberId
            };
            //setelah order selesai maka hit payment
            await this.$store
                .dispatch("order/createPayment", paramPayment)
                .then(resPay => {
                    let token = this.paymentArr.token;
                    var that = this;
                    window.snap.pay(token, {
                        onSuccess: async function (result) {
                            /* You may add your own implementation here */
                            // alert("payment success!");
                            console.log("onSuccess", result);
                            await that.$store.dispatch("order/selectPayment", {
                                id: that.invoiceArr.id
                            });
                            that.$router.push("/order-finish?id=" + that.invoiceArr.id);
                        },
                        onPending: async function (result) {
                            /* You may add your own implementation here */
                            // alert("wating your payment!");
                            console.log("onPending:", result);
                            await that.$store.dispatch("order/selectPayment", {
                                id: that.invoiceArr.id
                            });
                            that.$router.push("/order-finish?id=" + that.invoiceArr.id);
                        },
                        onError: function (result) {
                            /* You may add your own implementation here */
                            alert("payment failed!");
                            console.log(result);
                            // that.$store.dispatch("order/selectPayment", {
                            //   id: that.invoiceArr.id
                            // });
                            that.$router.push("/order-finish?id=" + that.invoiceArr.id);
                        },
                        onClose: function () {
                            /* You may add your own implementation here */
                            // alert("you closed the popup without finishing the payment");
                            that.$router.push("/order-finish?id=" + that.invoiceArr.id);
                        }
                    });

                    // this.$store.dispatch("order/destroyShoppingCart"); // sesuai kan dengan method di API

                    // this.$router.push("/login");
                })
                .catch(err => {
                    this.$router.push("/order-finish?id=" + this.invoiceArr.id);
                });
        },
        labelPackageProduct(value) {
            return labelPackageProduct(value);
        },
    },
    name: 'AiPricing'
}
</script>


// WEBPACK FOOTER //
// src/views/settings/components/AiPricing.vue